import { useState } from 'react'
import type { CatalogSkill, RoleSkillChoice } from '../services/api'

/**
 * * Picks formal skills from the catalog, and keeps one-off skills off that list.
 */
export function SkillPicker({
  catalog,
  value,
  onChange,
}: {
  catalog: CatalogSkill[]
  value: RoleSkillChoice[]
  onChange: (skills: RoleSkillChoice[]) => void
}) {
  const [customName, setCustomName] = useState('')
  const [customDescription, setCustomDescription] = useState('')
  const selectedIds = new Set(value.map((skill) => skill.catalogId).filter((id): id is string => Boolean(id)))
  const custom = value.filter((skill) => !skill.catalogId)

  const toggle = (item: CatalogSkill) => {
    if (selectedIds.has(item.id)) {
      onChange(value.filter((skill) => skill.catalogId !== item.id))
      return
    }
    onChange([...value, { catalogId: item.id, name: item.name, description: item.description }])
  }

  const addCustom = () => {
    const name = customName.trim()
    if (!name) {
      return
    }
    onChange([...value, { catalogId: null, name, description: customDescription.trim() }])
    setCustomName('')
    setCustomDescription('')
  }

  return (
    <div className="space-y-3">
      <ul className="space-y-2">
        {catalog.map((item) => (
          <li key={item.id}>
            <label className="flex items-start gap-2 text-sm text-primary" htmlFor={`skill-catalog-${item.id}`}>
              <input
                id={`skill-catalog-${item.id}`}
                name={`skill-catalog-${item.id}`}
                type="checkbox"
                checked={selectedIds.has(item.id)}
                onChange={() => toggle(item)}
              />
              <span>
                <span className="font-medium">{item.name}</span>
                {item.description ? <span className="block text-xs text-secondary">{item.description}</span> : null}
              </span>
            </label>
          </li>
        ))}
      </ul>
      {custom.length > 0 && (
        <ul className="space-y-1">
          {custom.map((skill) => (
            <li key={`${skill.name}-${skill.description}`} className="flex items-start justify-between gap-2 text-sm">
              <span>
                <span className="text-primary">{skill.name}</span>
                {skill.description ? <span className="block text-xs text-secondary">{skill.description}</span> : null}
              </span>
              <button
                type="button"
                className="text-xs text-secondary"
                onClick={() => onChange(value.filter((item) => item !== skill))}
              >
                Retirer
              </button>
            </li>
          ))}
        </ul>
      )}
      <div className="grid gap-2">
        <p className="text-xs text-secondary">Compétence hors catalogue</p>
        <input
          id="skill-custom-name"
          name="skill-custom-name"
          className="form-input"
          value={customName}
          onChange={(event) => setCustomName(event.target.value)}
          placeholder="Nom"
        />
        <input
          id="skill-custom-description"
          name="skill-custom-description"
          className="form-input"
          value={customDescription}
          onChange={(event) => setCustomDescription(event.target.value)}
          placeholder="Description"
        />
        <button type="button" className="button button--secondary" onClick={addCustom}>
          Ajouter cette compétence
        </button>
      </div>
    </div>
  )
}
